
import StyleProvider from '@/StyleProvider.vue';
import TheApp from './TheApp.vue';
import Vue, { PropType } from 'vue';
import i18n from '@/i18n';
import { validate } from 'jsonschema';
import isValidLanguageValidator from '@/validators/langLocaleValidator';
import { mapActions, mapState, PiniaVuePlugin } from 'pinia';
import { useStore as useLangStore } from '@/stores/lang';
import { pdpChoicesSchema } from '@/setters/pdpChoicesSetter';
import { priceDetailsSchema } from '@/setters/priceDetailsSetter';
import {
  PdpChoicesSetterType,
  PriceDetailsSetterType,
} from '@/setters/typings';
import { SupportedLangCodes } from '../../constants/languageCodes';

Vue.use(PiniaVuePlugin);

import { pinia } from '@/pinia';
import { ArtworkResult } from '@/components/w2pFileUploader';
import { AxiosError } from 'axios';
import { ProductPrintData } from '@midocean/webapps-shared-domain';

export default Vue.extend({
  components: {
    StyleProvider,
    TheApp,
  },
  props: {
    sapCustomerId: {
      type: String,
      required: false,
      default: '',
    },
    lang: {
      type: String as PropType<SupportedLangCodes>,
      required: false,
      default: 'en',
      validator: isValidLanguageValidator,
    },
    priceDetails: {
      type: Object as PropType<PriceDetailsSetterType>,
      required: true,
    },
    pdpChoices: {
      type: Object as PropType<PdpChoicesSetterType>,
      required: true,
    },
    productPrintData: {
      type: Object as PropType<ProductPrintData>,
      required: true,
    },
    uploadedFileData: {
      type: Array as PropType<ArtworkResult[]>,
      default: [],
    },
    isLoadingSpinnerActive: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isDetailLost: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    selectedMethod: {
      type: String,
      required: true,
    },
    errors: {
      type: [] as PropType<AxiosError>,
      default: [],
    },
    isFullDesignWithArtworksPathEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useLangStore, ['languageInUse']),
    priceDetailsValidationResults() {
      return validate(this.priceDetails, priceDetailsSchema).errors;
    },
    pdpChoicesValidationResults() {
      return validate(this.pdpChoices, pdpChoicesSchema).errors;
    },
  },
  mounted() {
    this.setLanguageLocale(this.lang);
  },
  methods: {
    ...mapActions(useLangStore, ['setLanguageLocale']),
  },
  i18n,
  pinia,
});
